(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  const khCartBubble = document.getElementById('cart-icon-bubble');
  if (khCartBubble) {
    const khSyncBagCount = () => {
      const count = khCartBubble.querySelector('[data-kh-cart-count]')?.textContent;
      if (count == null) return;
      document.querySelectorAll('[data-kh-bag-label]').forEach((link) => {
        const title = link.querySelector('[data-kh-bag-title]');
        const badge = link.querySelector('[data-kh-cart-count]');
        if (title && title.textContent !== link.dataset.khBagLabel) title.textContent = link.dataset.khBagLabel;
        if (badge && badge.textContent !== count) badge.textContent = count;
      });
    };
    new MutationObserver(khSyncBagCount).observe(khCartBubble, { childList: true, subtree: true, characterData: true });
    khSyncBagCount();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kh-contact"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selectRequestedEnquiry = () => {
      const requested = new URLSearchParams(window.location.search).get('subject');
      const field = document.getElementById('KHContactSubject');
      if (requested && field && Array.from(field.options).some(option => option.value === requested)) field.value = requested;
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', selectRequestedEnquiry, { once: true });
    else selectRequestedEnquiry();
    document.addEventListener('shopify:section:load', selectRequestedEnquiry);
  })();

  (() => {
    const setup = () => document.querySelectorAll('.kh-enquiry-select').forEach(root => {
      if(root.dataset.ready) return;
      root.dataset.ready = 'true';
      const native = root.querySelector('select'), custom = root.querySelector('.kh-enquiry-custom'), trigger = root.querySelector('.kh-enquiry-trigger'), list = root.querySelector('[role=listbox]'), options = Array.from(list.querySelectorAll('[role=option]'));
      const sync = () => {
        root.querySelector('.kh-enquiry-value').textContent = native.options[native.selectedIndex].textContent;
        options.forEach((option,index) => option.setAttribute('aria-selected', String(index === native.selectedIndex)));
      };
      const close = (focus) => {list.hidden = true; trigger.setAttribute('aria-expanded','false'); if(focus) trigger.focus();};
      const open = () => {list.hidden = false; trigger.setAttribute('aria-expanded','true'); options[native.selectedIndex].focus();};
      native.hidden = true; custom.hidden = false; sync();
      root.closest('.kh-field').querySelector('label').htmlFor = '';
      trigger.addEventListener('click', () => list.hidden ? open() : close(false));
      trigger.addEventListener('keydown', event => {if(['ArrowDown','ArrowUp'].includes(event.key)){event.preventDefault();open();}});
      options.forEach((option,index) => {
        option.addEventListener('click', () => {native.selectedIndex=index; native.dispatchEvent(new Event('change',{bubbles:true})); sync(); close(true);});
        option.addEventListener('keydown', event => {
          if(event.key === 'Escape'){event.preventDefault(); close(true);}
          if(event.key === 'Tab') close(false);
          let next=index;
          if(event.key==='ArrowDown') next=(index+1)%options.length;
          if(event.key==='ArrowUp') next=(index+options.length-1)%options.length;
          if(event.key==='Home') next=0;
          if(event.key==='End') next=options.length-1;
          if(next!==index){event.preventDefault(); options[next].focus();}
        });
      });
      native.addEventListener('change',sync);
      document.addEventListener('click', event => {if(!root.contains(event.target)) close(false);});
      root.addEventListener('focusout', event => {if(!root.contains(event.relatedTarget)) close(false);});
    });
    if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',setup,{once:true}); else setup();
    document.addEventListener('shopify:section:load',setup);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kh-footer"] && !Shopify.designMode) return;
  try {
    
function initKhFooterAccordions(root) {
  root.querySelectorAll('.kh-footer__column').forEach((column) => {
    if (column.classList.contains('is-collapsible')) return;
    const toggle = column.querySelector('.kh-footer__toggle');
    if (!toggle) return;
    toggle.setAttribute('aria-expanded', 'false');
    column.classList.add('is-collapsible');
    toggle.addEventListener('click', () => {
      toggle.setAttribute('aria-expanded', String(toggle.getAttribute('aria-expanded') !== 'true'));
    });
  });
}
initKhFooterAccordions(document);
document.addEventListener('shopify:section:load', (event) => initKhFooterAccordions(event.target));

  } catch(e) { console.error(e); }
})();
})();
